// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@sc/XDL/types";

import accordion from "@sc/XDL/PreStyle/accordion";
import breadcrumbs from "@sc/XDL/PreStyle/breadcrumbs";
import breakpoints from "@sc/XDL/PreStyle/breakpoints";
import button from "@sc/XDL/PreStyle/button";
import checkbox from "@sc/XDL/PreStyle/checkbox";
import colors from "@sc/XDL/PreStyle/colors";
import dataTable from "@sc/XDL/PreStyle/dataTable";
import datePicker from "@sc/XDL/PreStyle/datePicker";
import drawer from "@sc/XDL/PreStyle/drawer";
import dynamicDropdown from "@sc/XDL/PreStyle/dynamicDropdown";
import focus from "@sc/XDL/PreStyle/focus";
import footer from "@sc/XDL/PreStyle/footer";
import formField from "@sc/XDL/PreStyle/formField";
import globalStyle from "@sc/XDL/PreStyle/globalStyle";
import header from "@sc/XDL/PreStyle/header";
import icon from "@sc/XDL/PreStyle/icon";
import link from "@sc/XDL/PreStyle/link";
import lists from "@sc/XDL/PreStyle/lists";
import loadingOverlay from "@sc/XDL/PreStyle/loadingOverlay";
import loadingSpinner from "@sc/XDL/PreStyle/loadingSpinner";
import modal from "@sc/XDL/PreStyle/modal";
import overflowMenu from "@sc/XDL/PreStyle/overflowMenu";
import pagination from "@sc/XDL/PreStyle/pagination";
import panelMenu from "@sc/XDL/PreStyle/panelMenu";
import radio from "@sc/XDL/PreStyle/radio";
import select from "@sc/XDL/PreStyle/select";
import shadows from "@sc/XDL/PreStyle/shadows";
import tab from "@sc/XDL/PreStyle/tab";
import tag from "@sc/XDL/PreStyle/tag";
import textArea from "@sc/XDL/PreStyle/textArea";
import textField from "@sc/XDL/PreStyle/textField";
import toast from "@sc/XDL/PreStyle/toast";
import tooltip from "@sc/XDL/PreStyle/tooltip";
import typography from "@sc/XDL/PreStyle/typography";
import zIndex from "@sc/XDL/PreStyle/zIndex";

export default {
    breakpoints,
    colors,
    focus,
    shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    footer,
    // fileUpload,
    header,
    formField,
    // fieldSet,
    icon,
    // layoutTable,
    // layoutGroup,
    // layoutCell,
    link,
    lists,
    // lazyImage,
    loadingOverlay,
    loadingSpinner,
    // menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    // swatch,
    tab,
    tag,
    // tagsField,
    // textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
} as xBaseTheme;
